import { initializeApp } from "firebase/app";
import { getAuth, GoogleAuthProvider, inMemoryPersistence, setPersistence, signInWithCredential, signInWithPopup, signOut } from "firebase/auth";

const app = initializeApp({
  apiKey: "AIzaSyAnVDfFtlLbegfgxECEqxJaNh-tXUH-Q6Q",
  authDomain: "thetaexams.firebaseapp.com",
  projectId: "thetaexams",
  storageBucket: "thetaexams.firebasestorage.app",
  messagingSenderId: "162427714831",
  appId: "1:162427714831:web:c16fcd2669fd9e1de8927a",
  measurementId: "G-W016G70B0X",
});
const auth = getAuth(app);
const persistenceReady = setPersistence(auth, inMemoryPersistence);

export function nativeGoogleToken() {
  return new Promise((resolve, reject) => {
    const requestId = window.crypto.randomUUID();
    const cleanup = () => {
      clearTimeout(timer);
      window.ThetaGoogleAuth.onmessage = null;
    };
    const timer = setTimeout(() => {
      cleanup();
      reject(new Error("Google sign-in timed out. Please try again."));
    }, 120000);
    window.ThetaGoogleAuth.onmessage = (event) => {
      let result;
      try { result = JSON.parse(event.data); } catch { return; }
      if (result.requestId !== requestId) return;
      cleanup();
      if (result.idToken) resolve(result.idToken);
      else reject(new Error(result.error || "Google sign-in was cancelled."));
    };
    try {
      window.ThetaGoogleAuth.postMessage(JSON.stringify({ action: "signIn", requestId }));
    } catch (error) {
      cleanup();
      reject(error);
    }
  });
}

export async function getGoogleFirebaseToken() {
  await persistenceReady;
  const nativeBridge = typeof window.ThetaGoogleAuth?.postMessage === "function";
  const webView = /;\s*wv\)|\bThetaExamsAndroid\b/i.test(navigator.userAgent);
  if (webView && !nativeBridge) {
    throw new Error("Google sign-in needs an app update. Please use email and password for now.");
  }
  try {
    let result;
    if (nativeBridge) {
      const token = await nativeGoogleToken();
      result = await signInWithCredential(auth, GoogleAuthProvider.credential(token));
    } else {
      const provider = new GoogleAuthProvider();
      provider.setCustomParameters({ prompt: "select_account" });
      result = await signInWithPopup(auth, provider);
    }
    return await result.user.getIdToken();
  } finally {
    await signOut(auth);
  }
}
